<script>
    import { appComputed } from '@state/helpers'

    export default {
        name: 'OrganizationSelection',
        props: {
            value: {
                type: Array,
                default: () => []
            },
            items: {
                type: Array,
                default: () => []
            },
            title: {
                type: String,
                default: ''
            },
            hint: {
                type: String,
                default: ''
            },
            elevation: {
                type: String,
                default: '4'
            },
            singleSelect: {
                type: Boolean,
                default: false
            },
            labelSubmit: {
                type: String,
                default: ''
            },
            noActions: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                selectedOrgs: [],
                filterInput: ''
            }
        },

        computed: {
            ...appComputed,
            headers() {
                return [
                    { text: this.$vuetify.lang.t('$vuetify.entity.initials'), value: 'initials' },
                    { text: this.$vuetify.lang.t('$vuetify.entity.name'), value: 'name' },
                    { text: this.$vuetify.lang.t('$vuetify.entity.description'), value: 'description' }
                ]
            },
            tableConfig() {
                return {
                    items: this.items,
                    headers: this.headers,
                    itemKey: 'organisationId',
                    sortBy: 'initials',
                    search: this.filterInput,
                    dense: this.dense,
                    showSelect: !this.disabled,
                    singleSelect: this.singleSelect,
                    hideDefaultFooter: this.disabled,
                    itemsPerPage: 10
                }
            },
            filter() {
                return {
                    dense: this.dense,
                    hideDetails: true,
                    spellcheck: false,
                    clearable: true,
                    singleLine: true,
                    solo: true,
                    flat: true
                }
            },
            submitLabel() {
                return this.labelSubmit || this.$vuetify.lang.t('$vuetify.entity.copy')
            }
        },
        watch: {
            value(orgs) {
                this.selectedOrgs = orgs
            },
            selectedOrgs() {
                this.$emit('change', this.selectedOrgs)
            }
        },

        created() {
            this.selectedOrgs = this.value
        },

        methods: {
            onClickRow(row, props) {
                props.isSelected ? props.select(false) : props.select()
            },
            submit() {
                this.$emit('submit', this.selectedOrgs)
            }
        }
    }
</script>

<template>
    <VSheet :elevation="elevation">
        <VToolbar :dense="dense" flat>
            <VToolbarTitle>{{ title }}</VToolbarTitle>
            <VDivider class="mx-4" inset vertical/>
            <VSpacer/>
            <VTextField ref="filterInput" v-model="filterInput" v-bind="filter" class="vc-organization-selection__filter" :placeholder="$vuetify.lang.t('$vuetify.entity.filter')"/>
        </VToolbar>

        <VDataTable
            v-model="selectedOrgs"
            v-bind="tableConfig"
            class="vc-organization-selection-table px-2"
            @click:row="onClickRow">
            <template #top>
                <div class="caption px-2 pb-4" v-text="hint"></div>
            </template>
        </VDataTable>

        <VCardActions v-if="!noActions">
            <VSpacer/>
            <VBtn text @click.left="$emit('close')">{{ $vuetify.lang.t('$vuetify.actions.cancel') }}</VBtn>
            <VBtn text :disabled="!selectedOrgs.length" @click.left="submit" v-text="submitLabel"></VBtn>
        </VCardActions>
    </VSheet>
</template>

<style lang="scss">
    .vc-organization-selection-table {
        table {
            tbody tr {
                cursor: pointer;
            }
        }
    }
</style>
